import React from 'react';
import { BrainIcon, RocketIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  zap: ZapIcon,
  wrench: WrenchIcon,
  brain: BrainIcon,
  rocket: RocketIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="border-b border-line bg-canvasAlt" data-id="element-16" data-mp="3nohw4c37puwv">
      <div className="mx-auto max-w-3xl px-4 py-9 text-center sm:px-6" data-id="element-17" data-mp="38rr2kjg7zdf6">
        <p className="font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-18" data-mp="3dqvf9k2crta9">
          ¿Qué va a cambiar?
        </p>
        <h2 id="beneficios" className="mt-2 font-display text-lg font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-19" data-mp="2zsnjhfh1yy0o">
          Lo que puede cambiar cuando empezás a seguir un sistema
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-ink-muted" data-id="element-20" data-mp="xxwexpxt2v0v">
          Beneficios que podés aprovechar desde el momento en que accedés:
        </p>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-21" data-mp="2bdusoumgakcr">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-xl border border-line bg-surface p-4 text-center" data-id="element-22" data-mp="2l5ieog08n96u" data-mpi={i}>
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-soft" data-id="element-23" data-mp="1sgl7b7xkewsv">
                  <Icon size={17} className="text-accent" data-id="element-24" data-mp="1ogsz4wc32so1" />
                </span>
                <h3 className="mt-2.5 font-display text-sm font-extrabold uppercase text-ink" data-id="element-25" data-mp="22g2ddqgqbcpd">
                  {benefit.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-ink-muted sm:text-sm" data-id="element-26" data-mp="3dteazjlwaz33">
                  {benefit.desc}
                </p>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}